function FormatTime(e) {
    if (e < 10) return "0" + e;
    return e;
}

export default FormatTime